<template>
  <section v-if="summary && summary.current" class="lead-appointment" :class="{ 'lead-appointment--follow-up': summary.needsFollowUp }">
    <div class="lead-appointment__heading">
      <v-icon small :color="summary.needsFollowUp ? 'orange lighten-2' : 'teal lighten-2'">
        {{ summary.needsFollowUp ? 'mdi-calendar-alert' : 'mdi-calendar-check-outline' }}
      </v-icon>
      <strong>{{ statusLabel(summary.current.status) }}</strong>
    </div>
    <div>{{ typeLabel(summary.current.type) }} · {{ appointmentDate(summary.current) }}</div>
    <div v-if="summary.needsFollowUp && leadStatus === 'Wurde angeworben'" class="lead-appointment__action">
      Bitte Kontakt aufnehmen und einen neuen Termin vereinbaren.
    </div>
    <div v-if="summary.lastNoShow && summary.current.status !== 'noshow'" class="lead-appointment__previous">
      Bereits nicht gekommen: {{ typeLabel(summary.lastNoShow.type) }} am {{ appointmentDate(summary.lastNoShow) }}
    </div>
    <details v-if="history && history.length" class="lead-appointment__history">
      <summary>Terminverlauf ({{ history.length }})</summary>
      <ol>
        <li v-for="(entry, index) in reversedHistory" :key="index">
          <strong>{{ typeLabel(entry.type) }} · {{ statusLabel(entry.status) }}</strong>
          <span>{{ appointmentDate(entry) }}</span>
        </li>
      </ol>
    </details>
  </section>
</template>

<script>
export default {
  name: "LeadAppointmentHistory",
  props: {
    summary: { type: Object, default: null },
    history: { type: Array, default: () => [] },
    leadStatus: { type: String, default: "" },
  },
  computed: {
    reversedHistory() { return this.history.slice().reverse() },
  },
  methods: {
    typeLabel(type) {
      return { consultation: "Beratungstermin", trial: "Probetraining", guestbook: "Gästebuch" }[type] || "Termin"
    },
    statusLabel(status) {
      return {
        planned: "Termin vereinbart", checkedin: "Eingecheckt", done: "Termin wahrgenommen",
        noshow: "Nicht gekommen", cancelled: "Termin abgesagt", removed: "Terminzuordnung entfernt",
      }[status] || status
    },
    appointmentDate(entry) {
      const day = this.$moment(entry.date, "YYYY-MM-DD", true)
      return `${day.isValid() ? day.format("DD.MM.YYYY") : entry.date || ""}${entry.start ? `, ${entry.start} Uhr` : ""}`
    },
  },
}
</script>

<style scoped lang="scss">
.lead-appointment {
  margin: 8px 12px;
  padding: 12px;
  border: 1px solid rgba(77, 182, 172, 0.35);
  border-radius: 10px;
  background: rgba(77, 182, 172, 0.07);
  font-size: 0.8rem;
  line-height: 1.5;
  overflow-wrap: anywhere;

  &--follow-up {
    border-color: rgba(255, 183, 77, 0.55);
    background: rgba(255, 183, 77, 0.08);
  }
  &__heading {
    display: flex;
    align-items: center;
    gap: 8px;
    margin-bottom: 4px;
    font-size: 0.9rem;
  }
  &__action { margin-top: 6px; color: #ffcc80; }
  &__previous { margin-top: 8px; color: #ffcc80; }
  &__history {
    margin-top: 8px;
    summary { cursor: pointer; padding: 6px 0; }
    summary:focus-visible { outline: 2px solid #ffcc80; outline-offset: 2px; }
    ol { padding-left: 18px; margin: 6px 0 0; }
    li { margin-bottom: 8px; }
    span { display: block; opacity: 0.8; }
  }
}
</style>
